<div class="edgefinityBorderBottom">
    <h5>Edgefinity IoT Copyright <i class="fa fa-copyright" aria-hidden="true"></i> 2024 CYBRA Corporation</h5>
</div>